module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"dueIn":{"title":"Tempo até vencimento","years":"- | 1 ano | {count} anos","months":"- |1 mês | {count} meses","days":"- |1 dia | {count} dias","append":"e"}},"en-US":{"dueIn":{"title":"Time until pay","years":"- | 1 year | {count} years","months":"- |1 month | {count} months","days":"- |1 day | {count} days","append":"and"}}}')
  delete Component.options._Ctor
}
